exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-39187ca2] {\n  border: none;\n  border-bottom: 1px solid #ddd;\n  box-shadow: none;\n  font-size: 13px;\n}\ninput[data-v-39187ca2]:focus {\n  outline: none;\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid #ddd;\n}\n.filter-label[data-v-39187ca2] {\n  position: relative;\n}\n.filter-label .close[data-v-39187ca2] {\n  position: absolute;\n  right: 0px;\n  cursor: pointer;\n  z-index: 10;\n  padding: 5px;\n}\n.filter-label .fa-user[data-v-39187ca2] {\n  margin-right: 5px;\n}", ""]);

// exports
